// extracted by mini-css-extract-plugin
export default {"banner":"_1pnq4pZ0ezYCuFxBS7OSBt","text":"dICkvshUJ264Mba2wH4JE","cta":"_1DevinGGOZgrWPOhFZwB5i"};